module.exports = __webpack_public_path__ + "static/media/account-circle.032fdef3.svg";